import UltraDarkPage from './UltraDarkPage'

export default UltraDarkPage
